import { UserInfo } from 'common-js/types/User';

export default function setUsetifulSegmentation(userInfo: UserInfo) {
  const userId = userInfo?.impersonator?.userId
    ? userInfo.impersonator.userId.toString()
    : userInfo.userId?.toString();

  window.usetifulTags = {
    userId,
  };
}
